import { ISnippetsParams } from '@elgorditosalsero/react-gtm-hook/dist/models/GoogleTagManager';

export const analyticsConfig: {
  gtm: ISnippetsParams;
  cookieChimp: {
    id: string;
  };
} = {
  gtm: {
    id: import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID,
    environment: {
      gtm_auth: import.meta.env.VITE_GOOGLE_TAG_MANAGER_AUTH,
      gtm_preview: import.meta.env.VITE_GOOGLE_TAG_MANAGER_ENV,
    },
  },
  cookieChimp: {
    id: import.meta.env.VITE_COOKIE_CHIMP_ID,
  },
};
